// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file vision/generations/v1/list_recent_prompts.proto (package protos.vision.generations.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file vision/generations/v1/list_recent_prompts.proto.
 */
export const file_vision_generations_v1_list_recent_prompts: GenFile = /*@__PURE__*/
  fileDesc("Ci92aXNpb24vZ2VuZXJhdGlvbnMvdjEvbGlzdF9yZWNlbnRfcHJvbXB0cy5wcm90bxIccHJvdG9zLnZpc2lvbi5nZW5lcmF0aW9ucy52MSKHAQoYTGlzdFJlY2VudFByb21wdHNSZXF1ZXN0Ek0KBnBhcmFtcxgBIAEoCzI9LnByb3Rvcy52aXNpb24uZ2VuZXJhdGlvbnMudjEuTGlzdFJlY2VudFByb21wdHNSZXF1ZXN0LlBhcmFtcxocCgZQYXJhbXMSEgoKcHJvamVjdF9pZBgBIAEoCSKyAQoZTGlzdFJlY2VudFByb21wdHNSZXNwb25zZRJOCgZyZXN1bHQYASABKAsyPi5wcm90b3MudmlzaW9uLmdlbmVyYXRpb25zLnYxLkxpc3RSZWNlbnRQcm9tcHRzUmVzcG9uc2UuUmVzdWx0GkUKBlJlc3VsdBI7Cgdwcm9tcHRzGAEgAygLMioucHJvdG9zLnZpc2lvbi5nZW5lcmF0aW9ucy52MS5SZWNlbnRQcm9tcHQiTgoMUmVjZW50UHJvbXB0Eg4KBnByb21wdBgBIAEoCRIuCgpjcmVhdGVkX2F0GAIgASgLMhouZ29vZ2xlLnByb3RvYnVmLlRpbWVzdGFtcGIGcHJvdG8z", [file_google_protobuf_timestamp]);

/**
 * @generated from message protos.vision.generations.v1.ListRecentPromptsRequest
 */
export type ListRecentPromptsRequest = Message<"protos.vision.generations.v1.ListRecentPromptsRequest"> & {
  /**
   * @generated from field: protos.vision.generations.v1.ListRecentPromptsRequest.Params params = 1;
   */
  params?: ListRecentPromptsRequest_Params | undefined;
};

/**
 * Describes the message protos.vision.generations.v1.ListRecentPromptsRequest.
 * Use `create(ListRecentPromptsRequestSchema)` to create a new message.
 */
export const ListRecentPromptsRequestSchema: GenMessage<ListRecentPromptsRequest> = /*@__PURE__*/
  messageDesc(file_vision_generations_v1_list_recent_prompts, 0);

/**
 * @generated from message protos.vision.generations.v1.ListRecentPromptsRequest.Params
 */
export type ListRecentPromptsRequest_Params = Message<"protos.vision.generations.v1.ListRecentPromptsRequest.Params"> & {
  /**
   * @generated from field: string project_id = 1;
   */
  projectId: string;
};

/**
 * Describes the message protos.vision.generations.v1.ListRecentPromptsRequest.Params.
 * Use `create(ListRecentPromptsRequest_ParamsSchema)` to create a new message.
 */
export const ListRecentPromptsRequest_ParamsSchema: GenMessage<ListRecentPromptsRequest_Params> = /*@__PURE__*/
  messageDesc(file_vision_generations_v1_list_recent_prompts, 0, 0);

/**
 * @generated from message protos.vision.generations.v1.ListRecentPromptsResponse
 */
export type ListRecentPromptsResponse = Message<"protos.vision.generations.v1.ListRecentPromptsResponse"> & {
  /**
   * @generated from field: protos.vision.generations.v1.ListRecentPromptsResponse.Result result = 1;
   */
  result?: ListRecentPromptsResponse_Result | undefined;
};

/**
 * Describes the message protos.vision.generations.v1.ListRecentPromptsResponse.
 * Use `create(ListRecentPromptsResponseSchema)` to create a new message.
 */
export const ListRecentPromptsResponseSchema: GenMessage<ListRecentPromptsResponse> = /*@__PURE__*/
  messageDesc(file_vision_generations_v1_list_recent_prompts, 1);

/**
 * @generated from message protos.vision.generations.v1.ListRecentPromptsResponse.Result
 */
export type ListRecentPromptsResponse_Result = Message<"protos.vision.generations.v1.ListRecentPromptsResponse.Result"> & {
  /**
   * @generated from field: repeated protos.vision.generations.v1.RecentPrompt prompts = 1;
   */
  prompts: RecentPrompt[];
};

/**
 * Describes the message protos.vision.generations.v1.ListRecentPromptsResponse.Result.
 * Use `create(ListRecentPromptsResponse_ResultSchema)` to create a new message.
 */
export const ListRecentPromptsResponse_ResultSchema: GenMessage<ListRecentPromptsResponse_Result> = /*@__PURE__*/
  messageDesc(file_vision_generations_v1_list_recent_prompts, 1, 0);

/**
 * @generated from message protos.vision.generations.v1.RecentPrompt
 */
export type RecentPrompt = Message<"protos.vision.generations.v1.RecentPrompt"> & {
  /**
   * @generated from field: string prompt = 1;
   */
  prompt: string;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 2;
   */
  createdAt?: Timestamp | undefined;
};

/**
 * Describes the message protos.vision.generations.v1.RecentPrompt.
 * Use `create(RecentPromptSchema)` to create a new message.
 */
export const RecentPromptSchema: GenMessage<RecentPrompt> = /*@__PURE__*/
  messageDesc(file_vision_generations_v1_list_recent_prompts, 2);

